import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import store from './store';
import router from './router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    // Log stack trace to identify the source
    console.group('🔍 ResizeObserver Error Source');
    console.trace('Full stack trace:');
    console.log('Error args:', args);
    console.groupEnd();
    return;
  }
  originalError.apply(console, args);
};

// Alternative: Use Error event listener for more details
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    console.group('🔍 ResizeObserver Error Detected');
    console.log('Error event:', event);
    console.log('Error stack:', event.error?.stack);
    console.trace('Current stack trace:');
    console.groupEnd();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <CssBaseline />
      <RouterProvider router={router} />
    </Provider>
  </ThemeProvider>
);

const notification = ReactDOM.createRoot(document.getElementById('notification'));
notification.render(
  <ToastContainer
    theme="colored"
    autoClose={1000}
    hideProgressBar
    pauseOnFocusLoss
    pauseOnHover
    draggable
    position="top-right"
    closeOnClick
  />
);
